import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Gallery from "@/pages/Gallery";
import RenderPage from "@/pages/RenderPage";
import TitlePage from "@/pages/TitlePage";
import AdminLogin from "@/pages/AdminLogin";
import WaitlistDashboard from "@/pages/WaitlistDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/kit" element={<Gallery />} />
          <Route path="/render/:id" element={<RenderPage />} />
          <Route path="/render-title/:id" element={<TitlePage />} />
          <Route path="/admin" element={<Navigate to="/admin/waitlist" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/waitlist" element={<WaitlistDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
